import { Building2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { EntityConfig } from '../types';

export interface MasterCompanyCategory {
  id: string;
  code: string;
  display_name: string;
  description: string | null;
  is_active: boolean;
  sort_order: number;
  created_at: string;
}

export const masterCompanyCategoriesConfig: EntityConfig<MasterCompanyCategory> = {
  name: 'masterCompanyCategories',
  singularName: 'Category',
  pluralName: 'Company Categories',
  tableName: 'master_company_categories',
  keyField: 'id',
  icon: <Building2 className="h-4 w-4" />,
  description: 'Categories for classifying companies',
  category: 'master',
  permissionModule: 'settings',

  columns: [
    {
      id: 'sort_order',
      header: 'Order',
      accessorKey: 'sort_order',
      sortable: true,
      width: '80px',
    },
    {
      id: 'code',
      header: 'Code',
      accessorKey: 'code',
      sortable: true,
      cell: (row) => <span className="font-mono text-sm">{row.code}</span>,
    },
    {
      id: 'display_name',
      header: 'Display Name',
      accessorKey: 'display_name',
      sortable: true,
    },
    {
      id: 'description',
      header: 'Description',
      accessorKey: 'description',
      cell: (row) => row.description || <span className="text-muted-foreground">-</span>,
    },
    {
      id: 'is_active',
      header: 'Status',
      accessorKey: 'is_active',
      width: '100px',
      cell: (row) => (
        <Badge variant={row.is_active ? 'default' : 'secondary'}>
          {row.is_active ? 'Active' : 'Inactive'}
        </Badge>
      ),
    },
  ],

  formFields: [
    {
      name: 'code',
      label: 'Code',
      type: 'text',
      required: true,
      placeholder: 'e.g., my_code',
      helpText: 'Unique identifier (lowercase with underscores)',
    },
    {
      name: 'display_name',
      label: 'Display Name',
      type: 'text',
      required: true,
      placeholder: 'e.g., My Display Name',
    },
    {
      name: 'description',
      label: 'Description',
      type: 'textarea',
      gridSpan: 2,
    },
    {
      name: 'sort_order',
      label: 'Sort Order',
      type: 'number',
      defaultValue: 0,
    },
    {
      name: 'is_active',
      label: 'Active',
      type: 'switch',
      defaultValue: true,
    },
  ],

  searchFields: ['code', 'display_name'],
  defaultOrderBy: { field: 'sort_order', ascending: true },

  features: {
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canBulkDelete: false,
    showActivityLog: false,
  },
};
